import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from '../../containers/Text';
import { getUserFullname } from '../accounts/common-components/utils';

const MissedTable = ({ userMissedFiles = [], filesAttribute = 'files' }) => {
  const { t } = useTranslation();

  const isTableEmpty = userMissedFiles.length === 0;

  const tableRows = () => {
    return userMissedFiles.map((userFiles) => {
      return userFiles[filesAttribute].map((f, id) => {
        const fullName = getUserFullname(userFiles.user);

        return (
          <tr key={id}>
            <td style={{ maxWidth: '100%' }} className="date">
              <Text text={f.date || ''} />
            </td>
            <td style={{ maxWidth: '100%' }} className="date">
              <Text text={f.fileNumber || ''} />
            </td>
            <td style={{ maxWidth: '100%' }} className="number">
              <Text text={f.fileName} />
            </td>
            <td style={{ maxWidth: '100%' }} className={'amount'}>
              <Text text={fullName} />
            </td>
            <td style={{ maxWidth: '100%' }} className={'amount'}>
              <Text text={userFiles.user?.identity_number || ''} />
            </td>
            <td style={{ maxWidth: '100%' }} className={'amount'}>
              <Text text={userFiles.user?.santec_account_id || ''} />
            </td>
          </tr>
        );
      });
    });
  };

  const noTableRows = () => {
    return (
      <tr>
        <td className="date" colSpan={6}>
          <Text text={t('no-files')} />
        </td>
      </tr>
    );
  };

  return (
    <div className="missed-table-container">
      <table className="missed-table">
        <thead>
          <tr>
            <th style={{ maxWidth: '100%' }} className="date">
              <Text text={t('date')} />
            </th>
            <th style={{ maxWidth: '100%' }} className="date">
              <Text text={t('file-number')} />
            </th>
            <th style={{ maxWidth: '100%' }} className="number">
              <Text text={t('file-name')} />
            </th>
            <th style={{ maxWidth: '100%' }} className="amount">
              <Text text={t('name')} />
            </th>
            <th style={{ maxWidth: '100%' }} className="amount">
              <Text text={t('identity-number')} />
            </th>
            <th style={{ maxWidth: '100%' }} className="amount">
              <Text text={t('agent-id')} />
            </th>
          </tr>
        </thead>
        <tbody>{!isTableEmpty ? tableRows() : noTableRows()}</tbody>
      </table>
    </div>
  );
};

export default MissedTable;
